// ==============================|| OVERRIDES - LINK ||============================== //

export default function Link(theme) {
  return {
    MuiLink: {
      defaultProps: {
        color: theme.palette.link.primary,
        underline: 'hover',
      },
      styleOverrides: {
        root: {
          '&:link, &:visited, &:hover, &:active': {
            color: theme.palette.link.primary,
          },
        },
      },
    },
  }
}
